



















import { computed, defineComponent, PropType } from '@vue/composition-api';
import ObjectComponent from './Object.vue';
import type { RenderOptions } from './types';

export default defineComponent({
  name: 'ObjectArray',
  components: {
    ObjectComponent,
  },
  props: {
    schema: {
      // The root schema of the item to render
      type: Object,
      required: true,
    },
    data: {
      // The data at the matching level of schema
      type: Array,
      required: true,
    },
    options: {
      type: Object as PropType<RenderOptions>,
      required: false,
      default: () => ({} as RenderOptions),
    },
  },
  setup(props) {
    const primaryKey = computed(() => props.options.primaryKey);

    function objectKey(item: Record<string, unknown>) {
      const pk = primaryKey.value;
      if (pk && pk in item) {
        return item[pk];
      }

      return Object.values(item).join('|');
    }

    return {
      primaryKey,
      objectKey,
    };
  },
});
